import * as actionTypes from "./actionTypes";
const initialState = {
    values: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    visitsList: [],

    //form specific:
    visitsData: {},
    visitorLastVisitsTable: [],

    loading: false,

    loadingCheckInRequest: false,
    loadingCheckOutRequest: false,

    loadingCreateVisitRequest: false,
    createVisitSuccess: false,

    checkOutRequestSuccess: false,
    checkInRequestSuccess: false,

    error: undefined
};

const visitsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.VISIT_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.VISIT_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.VISIT_SEARCH_FAILED:
            return {
                ...state,
                loading: false,
            };

        case actionTypes.VISIT_CHECK_OUT_REQUEST:
            return {
                ...state,
                loadingCheckOutRequest: true,
            };
        case actionTypes.VISIT_CHECK_OUT_SUCCESS:
            return {
                ...state,
                loadingCheckOutRequest: false,
                checkOutRequestSuccess: true
            };
        case actionTypes.VISIT_CHECK_OUT_FAILED:
            return {
                ...state,
                loadingCheckOutRequest: false,
                checkOutRequestSuccess: false
            };
        case actionTypes.VISIT_CHECK_IN_REQUEST:
            return {
                ...state,
                loadingCheckInRequest: true,
            };
        case actionTypes.VISIT_CHECK_IN_SUCCESS:
            return {
                ...state,
                loadingCheckInRequest: false,
                checkInRequestSuccess: true
            };
        case actionTypes.VISIT_CHECK_IN_FAILED:
            return {
                ...state,
                loadingCheckInRequest: false,
                checkInRequestSuccess: false
            };
        case actionTypes.CREATE_VISIT_REQUEST:
            return {
                ...state,
                loadingCreateVisitRequest: true
            };
        case actionTypes.CREATE_VISIT_SUCCESS:
            return {
                ...state,
                loadingCreateVisitRequest: false,
                visitCreated: true
            };
        case actionTypes.CREATE_VISIT_FAILED:
            return {
                ...state,
                loadingCreateVisitRequest: false,
                visitCreated: false,
                error: payload
            };
        case actionTypes.VISITOR_LAST_VISITS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.VISITOR_LAST_VISITS_SUCCESS:
            return {
                ...state,
                loading: false,
                visitorLastVisitsTable: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.VISITOR_LAST_VISITS_FAILED:
            return {
                ...state,
                loading: false
            };
        case actionTypes.RESET_VISIT_FORM:
            return {
                ...state,
                visitsData: {},
                loadingCheckInRequest: false,
                createVisitSuccess: false,
                error: undefined
            };
        case actionTypes.RESET_VISITS_RESULTS:
            return {
                ...state,
                table: {
                    data: [],
                    sort: {
                        property: undefined,
                        direction: undefined
                    },
                    totalElements: undefined,
                    pageNumber: undefined,
                    totalPages: undefined
                }
            }
        default:
            return state;
    }
};

export default visitsReducer;